import * as PoliciesActions from './lib/+state/policies.actions';

import * as PoliciesFeature from './lib/+state/policies.reducer';

import * as PoliciesSelectors from './lib/+state/policies.selectors';

export { PoliciesService } from './lib/services/policies.service';
// export * from './lib/+state/policies.facade';

export * from './lib/+state/policies.models';
export * from './lib/services/policies2.service';

export { PoliciesActions, PoliciesFeature, PoliciesSelectors };
export * from './lib/shared-data-access-policies.module';
